var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 67,
    viewBox: "0 0 76 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1000006193"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624664",
    x: 1.05566,
    y: 1.13184,
    width: 73.8882,
    height: 64.4022,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624673",
    x: 6.62292,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624674",
    x: 11.7307,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624675",
    x: 16.8386,
    y: 8.15845,
    width: 2.91878,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624676",
    x: 32.1622,
    y: 8.15845,
    width: 11.6751,
    height: 2.91878,
    rx: 1.45939,
    fill: "#7646D7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624666",
    x: 7.62292,
    y: 18.6444,
    width: 60.7537,
    height: 37.4035,
    rx: 2.64847,
    stroke: "#7646D7",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 505",
    d: "M25.595 46.4674L29.2434 36.268L56.9718 10.3639C63.3931 7.73695 62.8094 12.6746 61.7148 15.4717L36.1755 43.5486L25.595 46.4674Z",
    fill: "white",
    stroke: "#7646D7",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.5e70faa3b2bac5998e11ff5a11dcedd1.svg";
export { ForwardRef as ReactComponent };